export const LINE_TYPE = Object.freeze({
	multiLine: 'multi_line',
	singleLine: 'single_line',
})

export const STATIC_CLASSES = Object.freeze({
	content: 'q-text-content',
})
